import posthog from 'posthog-js';

type ReportContext = {
  /**
   * Stable identifier for where the error happened.
   * Examples: "api:tickets:patch", "firma:open", "render:tickets-page"
   * NEVER include patient data, names, IDs, or values.
   */
  context: string;
  /** Optional: HTTP status, route, or other shape-only metadata */
  extra?: Record<string, string | number | boolean | null>;
};

/**
 * Report a caught error to PostHog Error Tracking.
 * Safe to call before PostHog has initialized — no-ops cleanly.
 * Never throws.
 */
export function reportError(error: unknown, ctx: ReportContext): void {
  try {
    if (typeof window === 'undefined') return;
    if (!posthog || !(posthog as any).__loaded) return;

    const err = error instanceof Error ? error : new Error(String(error));
    posthog.captureException(err, {
      context: ctx.context,
      ...(ctx.extra ?? {}),
    });
  } catch {
    // never let error reporting break the app
  }
}
